import { FETCH_NOTIFICATION_FAILURE, FETCH_NOTIFICATION_REQUEST, FETCH_NOTIFICATION_SUCCESS, UPDATE_NOTIFCATION_SUCCESS } from "../actions/NotificationActions";


const initialState = {
  allNotifications: [],
  loading: false,
  error: null,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        allNotifications: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_NOTIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_NOTIFCATION_SUCCESS:
      return {
        ...state,
        allNotifications: state.allNotifications.map(n =>
          n._id === action.payload.notificationId
            ? { ...n, isRead: true }
            : n
        ),
      };
    default:
      return state;
  }
};

export default notificationReducer;
